export class LoadPendingNotifications {
  static readonly type = '[Notifications] LoadPendingNotifications';
}

export class LoadPersistentNotifications {
  static readonly type = '[Notifications] LoadPersistentNotifications';
}

export class DismissNotification {
  static readonly type = '[Notifications] DismissNotification';

  constructor(public id: string) {}
}

export class DismissAllNotifications {
  static readonly type = '[Notifications] DismissAllNotifications';
}
